const CartSolidIcon: React.FC<{ size?: string; color?: string }> = ({
  size = "24px",
  color = "#9AA9B3",
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 25"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_4699_653)">
        <path d="M22.713 4.577C22.4317 4.23944 22.0796 3.96795 21.6815 3.78182C21.2835 3.59568 20.8494 3.49946 20.41 3.5H4.242L4.2 3.149C4.11405 2.41942 3.76338 1.74673 3.21449 1.25848C2.6656 0.770223 1.95663 0.500342 1.222 0.5L1 0.5C0.734784 0.5 0.48043 0.605357 0.292893 0.792893C0.105357 0.98043 0 1.23478 0 1.5C0 1.76522 0.105357 2.01957 0.292893 2.20711C0.48043 2.39464 0.734784 2.5 1 2.5H1.222C1.46693 2.50003 1.70334 2.58996 1.88637 2.75272C2.06941 2.91547 2.18634 3.13975 2.215 3.383L3.591 15.083C3.73385 16.2998 4.31848 17.4218 5.23391 18.236C6.14934 19.0502 7.33185 19.5 8.557 19.5H19C19.2652 19.5 19.5196 19.3946 19.7071 19.2071C19.8946 19.0196 20 18.7652 20 18.5C20 18.2348 19.8946 17.9804 19.7071 17.7929C19.5196 17.6054 19.2652 17.5 19 17.5H8.557C7.93806 17.4983 7.3348 17.3051 6.82994 16.9471C6.32507 16.589 5.94331 16.0835 5.737 15.5H17.657C18.8293 15.5001 19.9643 15.0882 20.8638 14.3364C21.7633 13.5846 22.37 12.5407 22.578 11.387L23.363 7.033C23.4414 6.60101 23.4237 6.15707 23.3114 5.73264C23.1991 5.30821 22.9948 4.91368 22.713 4.577ZM21.4 6.678L20.614 11.032C20.4891 11.725 20.1245 12.352 19.5839 12.8032C19.0433 13.2544 18.3612 13.5011 17.657 13.5H5.419L4.478 5.5H20.41C20.5569 5.49912 20.7022 5.53062 20.8355 5.59226C20.9689 5.65389 21.087 5.74415 21.1815 5.85661C21.276 5.96907 21.3446 6.10097 21.3824 6.24294C21.4201 6.3849 21.4262 6.53344 21.4 6.678Z" />
        <path d="M7 24.5C8.10457 24.5 9 23.6046 9 22.5C9 21.3954 8.10457 20.5 7 20.5C5.89543 20.5 5 21.3954 5 22.5C5 23.6046 5.89543 24.5 7 24.5Z" />
        <path d="M17 24.5C18.1046 24.5 19 23.6046 19 22.5C19 21.3954 18.1046 20.5 17 20.5C15.8954 20.5 15 21.3954 15 22.5C15 23.6046 15.8954 24.5 17 24.5Z" />
      </g>
      <defs>
        <clipPath id="clip0_4699_653">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export default CartSolidIcon;
